/**
 * Standardized spacing and vertical/horizontal rhythm used in the Gem Design
 * System.
 *
 * Large dimensions should be defined relative to `M`, `L`, or `XL` to ensure
 * the interface is always based on the standard grid.
 *
 * @example
 * maxInlineSize: Spacing.L * 40,
 *
 * @note See `Size` for more specific patterns.
 * @see https://workwithopal.atlassian.net/wiki/spaces/GDS/pages/89063429/Layout
 */
export const enum Spacing {
  /**
   * Tight spaces like between form labels and the fields they reference.
   */
  XS = 4,
  /**
   * Most padding situations inside objects. (2`XS`, ½`M`)
   */
  S = XS * 2,
  /**
   * Compact gutter spacing. (4`XS`, 2`S`)
   */
  M = XS * 4,
  /**
   * Standard gutter spacing. (6`XS`, 3`S`, ³⁄₂`M`)
   */
  L = XS * 6,
  /**
   * Comfortable gutter spacing. (12`XS`, 6`S`, 3`M`, 2`L`)
   */
  XL = XS * 12,
}
